import { Injectable, inject } from '@angular/core';
import { PushQuoteService } from './push-quote';

@Injectable({ providedIn: 'root' })
export class PriceService {
  private readonly pushQuoteService = inject(PushQuoteService);
  private activeIsins: string[] = [];

  // Subscribe with accumulated updates
  public subscribeToQuotesBuffered(isins: string[]) {
    this.activeIsins = isins;
    return this.pushQuoteService.subscribeMultiAccumulated(isins);
  }

  // Stop receiving quotes
  public unsubscribeFromQuotes(): void {
    if (!this.activeIsins.length) return;

    this.pushQuoteService.unsubscribeMulti(this.activeIsins);
    this.activeIsins = [];
  }
}
